import script from "./ProProxyUiBoxSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ProProxyUiBoxSettings.vue?vue&type=script&setup=true&lang=js"

import "./ProProxyUiBoxSettings.vue?vue&type=style&index=0&id=690be92a&scoped=true&lang=css"
import "./ProProxyUiBoxSettings.vue?vue&type=style&index=1&id=690be92a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690be92a"]])

export default __exports__